import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import FormSearchCriteria from '../../../../library/form/components/FormSearchCriteria';
import FormWrapper from '../../../../library/form/components/FormWrapper';

const StockCheckSearch = (props) => {
    const { formObject, viewData } = props;

    if (!viewData)
        return (null);

    console.log("StockSearch",formObject);

    return (
        <div>
            <div className="uiEditableContent">
                <div className="uiRow">
                    <div className="uiSpacer15">
                        <FormWrapper customWrapper="div" formObject={formObject} rowKey="" action={{ paramName: "searchCriteriaContainer" }} >
                            <FormSearchCriteria formObject={formObject} inlineCriteria enableSearch={false} enableGroups={false} enablefav={false}
                                    action={{ actionId: "refresh", refreshMode:"dep", viewDataReload: 1, actionParam:{ partialupdate: "1"} }}
                            />
                        </FormWrapper>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withView(StockCheckSearch, "stockCheckCriteria", "stockCheckListSystem,stockCheckHeader")
